import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import {
  SettlementDetectionList,
  ShearingObliqueList,
  SpaceList,
} from "@/api/modelingList";
import { delMeasurePoint } from "@/views/inspectionLite/viewLite/inspect/viewData/liteDraw";
import axios from "axios";
import { changeFloorSrd } from "@/utils/rlModuleUtils";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js`;
import { projectConfig, configEdit } from "@/api/project";
import { changeBackgroundGrid } from "@/views/inspectionLite/components/ModulePage/utils/settingBtn.js";
import store from "@/store";
import { engineerInfoDetail } from "@/api/hiSurveyApi";
import {
  toggleAxisDist,
  isPointInPolygon,
  lineInsection,
  ptOnLine,
  lineArcIntersection1,
  calculateArcCenterByCenter,
} from "@/rlMxModules/operate/operateApi";
import {
  McDbHatch,
  McGePoint3d,
  McGePoint3dArray,
  McDb,
  McCmColor,
  MxCpp,
  McDbPolyline,
} from "mxcad";
import { MovePt } from "@/rlMxModules/operate/structural.js";
import { drawTexts } from "@/views/detection/components/construction/utils/drawDetection";
import { rlTextData } from "@/rlMxModules/rlDataClass/rlTextData.js";
import { isMobileDevice } from "@/utils/matchMedia.js";
// import { baseURL } from "@/utils/request";
const sSaveProgramUrl = "https://dwgtoimg.rili-tech.com/mxcad/savedwg";
const sSaveProgramPdfUrl = "https://dwgtoimg.rili-tech.com/mxcad/savepdf";
const sSaveProgramJpgUrl = "https://dwgtoimg.rili-tech.com/users/tools";
const baseUrl = "https://dwgtoimg.rili-tech.com/";
const saveDwgUrl = "/mxcad/file/";
const baseURL = process.env.VUE_APP_BASE_URL;
const saveJpgUrl = `${baseURL}/common/upload`;
let compassId = []; //指北针对象的id
let allHatchId = []; //所有填充对象的id
let otherLineId = []; //其他线段对象的id
let ents = {
  rlAxis: [],
  rlGrid: [],
  rlColSeg: [],
  rlBeamSeg: [],
  rlWallSeg: [],
  rlSlab: [],
  rlSlabHole: [],
  rlCantiSlab: [],
  rlSubBeam: [],
  rlWallHole: [],
  rlModelNo: [],
  rlText: [],
  rlPartitionWallSeg: [],
  rlDoors: [],
  rlWindows: [],
  rlUse: [],
}; //构件列表
let beforeShow = {}; //之前构件的显隐状态
//PDF转jpg二进制
let pdfCanvas = null;
let pdfContext = null;
export const pdfToJpgBinary = async (pdfUrl) => {
  let pdf = null;
  let page = null;
  let imageData = null;
  try {
    // 先下载PDF文件内容
    const response = await fetch(pdfUrl);
    if (!response.ok) {
      throw new Error("PDF下载失败");
    }
    const pdfData = await response.arrayBuffer();
    // return pdfData;
    // 加载PDF文件
    const loadingTask = pdfjsLib.getDocument({ data: pdfData });
    pdf = await loadingTask.promise;
    page = await pdf.getPage(1);

    const isMobile = isMobileDevice();
    const maxDimension = isMobile ? 400 : 2000; // 降低桌面设备的最大尺寸

    // 设置合适的分辨率
    const desiredWidth = 5000; // A4纸宽度对应的像素(300dpi)
    const viewport = page.getViewport({ scale: 1 });
    let scale = maxDimension / Math.max(viewport.width, viewport.height);
    // const scale = desiredWidth / viewport.width;
    const scaledViewport = page.getViewport({ scale });
    // 创建canvas
    if (!pdfCanvas) {
      pdfCanvas = document.createElement("canvas");
      pdfContext = pdfCanvas.getContext("2d", { alpha: false });
    }
    pdfCanvas.width = scaledViewport.width;
    pdfCanvas.height = scaledViewport.height;
    // const context = canvas.getContext("2d", { alpha: false });
    // 设置白色背景
    pdfContext.fillStyle = "white";
    pdfContext.fillRect(0, 0, pdfCanvas.width, pdfCanvas.height);
    // 渲染PDF页面到canvas
    const renderContext = {
      canvasContext: pdfContext,
      viewport: scaledViewport,
      background: "white",
    };
    await page.render(renderContext).promise;
    // 图像处理 - 将所有颜色转换为黑色，提高线条清晰度
    imageData = pdfContext.getImageData(
      0,
      0,
      pdfCanvas.width,
      pdfCanvas.height
    );
    const data = imageData.data;

    // 处理每个像素
    for (let i = 0; i < data.length; i += 4) {
      // 计算灰度值
      const gray = (data[i] + data[i + 1] + data[i + 2]) / 3;

      // 设置阈值，低于阈值的像素设为黑色，高于阈值的设为白色
      const threshold = 250; // 调整这个值可以控制线条的粗细
      const newValue = gray < threshold ? 0 : 255;

      // 设置所有颜色通道为相同的值（黑白）
      data[i] = newValue; // R
      data[i + 1] = newValue; // G
      data[i + 2] = newValue; // B
      // Alpha通道保持不变
    }

    // 将处理后的图像数据放回canvas
    pdfContext.putImageData(imageData, 0, 0);

    // 将canvas转换为二进制数据
    return new Promise((resolve, reject) => {
      pdfCanvas.toBlob(
        async (blob) => {
          if (blob) {
            try {
              // 将Blob转换为ArrayBuffer
              const arrayBuffer = await blob.arrayBuffer();
              // 创建Uint8Array视图
              const uint8Array = new Uint8Array(arrayBuffer);
              resolve(uint8Array);
            } catch (error) {
              console.error("转换失败", error);
              reject(error);
            }
          } else {
            reject(new Error("图片转换失败"));
          }
        },
        "image/jpeg",
        1.0 // 使用最高质量
      );
    });
  } catch (error) {
    console.error("PDF转JPG失败", error);
    throw error;
  } finally {
    if (page) page.cleanup();
    if (pdf) pdf.destroy();
    // 释放imageData（帮助垃圾回收）
    if (imageData) {
      // console.log("imageData", imageData);
      // imageData.data = null;
      imageData = null;
    }
  }
};
// 组件销毁时，释放canvas资源
export const destroyPdfCanvas = () => {
  if (pdfCanvas) {
    pdfCanvas.width = 0;
    pdfCanvas.height = 0;
    pdfCanvas = null;
  }
  if (pdfContext) {
    pdfContext = null;
  }
};
async function renderPdfToCanvasWithSmallerSize(page) {
  const viewport = page.getViewport({ scale: 1 });
  const scale = 1000 / Math.max(viewport.width, viewport.height); // 进一步缩小
  const scaledViewport = page.getViewport({ scale });

  const canvas = document.createElement("canvas");
  canvas.width = scaledViewport.width;
  canvas.height = scaledViewport.height;
  const context = canvas.getContext("2d");

  context.fillStyle = "white";
  context.fillRect(0, 0, canvas.width, canvas.height);

  await page.render({
    canvasContext: context,
    viewport: scaledViewport,
  }).promise;

  return {
    canvas,
    imageUrl: canvas.toDataURL("image/png"),
    imageData: context.getImageData(0, 0, canvas.width, canvas.height),
  };
}
//PDF转JPG
export const pdfToJpg = async (floorName) => {
  try {
    let time = new Date();
    //获取当前日期,格式:20250307
    let date =
      time.getFullYear() +
      (time.getMonth() + 1).toString().padStart(2, "0") +
      time.getDate().toString().padStart(2, "0");
    let fileName = `${store.state.cadModules.rlProject_name}_${floorName}_${date}`;
    const pdfUrl = await exportPdf(fileName + ".pdf");
    if (pdfUrl) {
      const imageData = await pdfToJpgBinary(pdfUrl);

      // 创建FormData对象
      const formData = new FormData();
      const blob = new Blob([imageData], { type: "image/jpeg" });
      const file = new File([blob], fileName + ".jpg", {
        type: "image/jpeg",
      });
      formData.append("file", file);
      formData.append("scene", "photo");

      // 发送上传请求
      const { data } = await axios.post(saveJpgUrl, formData, {
        headers: {
          token: store.state.user.token,
        },
      });

      if (data.code === 200) {
        return { name: floorName, img: data.data.url };
      }
    }
    return null;
  } catch (error) {
    console.error("PDF转JPG失败", error);
    throw error;
  }
};
//上传图片
export const uploadJpg = async () => {
  try {
    showFullScreenLoading("导出中...");
    //获取项目配置
    let gridShow = localStorage.getItem("uSettings");
    if (gridShow) {
      gridShow = JSON.parse(gridShow);
      gridShow = gridShow.gridShow;
    }
    //隐藏背景栅格
    changeBackgroundGrid(false);
    const { data } = await projectConfig({
      project_id: store.state.cadModules.rlProject_id,
    });

    let buildingPlane = await uploadBuildingPlaneJpg();
    let structurePlane = await uploadStructurePlaneJpg();
    let sink = await uploadSinkJpg();
    let tilt = await uploadTiltJpg();
    let floorCrack = (await uploadFloorCrackJpg()) || [];

    let id = 10000;
    let buildingPlaneUrls = {
      id: id++,
      name: "建筑平面图",
      originalName: "建筑平面图",
      field: "buildingPlane",
      children: [],
    };
    for (let i = 0; i < buildingPlane.length; i++) {
      buildingPlane[i].parent_name = "建筑平面图";
      buildingPlane[i].originalName = buildingPlane[i].name;
      buildingPlane[i].id = id++;
    }
    buildingPlaneUrls.children = buildingPlane;

    let structurePlaneUrls = {
      id: id++,
      name: "结构平面图",
      originalName: "结构平面图",
      field: "structurePlane",
      children: [],
    };
    for (let i = 0; i < structurePlane.length; i++) {
      structurePlane[i].parent_name = "结构平面图";
      structurePlane[i].originalName = structurePlane[i].name;
      structurePlane[i].id = id++;
    }
    structurePlaneUrls.children = structurePlane;

    let sinkUrls = {
      id: id++,
      name: "沉降测点图",
      originalName: "沉降测点图",
      field: "sink",
      children: [],
    };
    for (let i = 0; i < sink.length; i++) {
      sink[i].parent_name = "沉降测点图";
      sink[i].originalName = sink[i].name;
      sink[i].id = id++;
    }
    sinkUrls.children = sink;
    let tiltUrls = {
      id: id++,
      name: "倾斜测点图",
      originalName: "倾斜测点图",
      field: "tilt",
      children: [],
    };
    for (let i = 0; i < tilt.length; i++) {
      tilt[i].parent_name = "倾斜测点图";
      tilt[i].originalName = tilt[i].name;
      tilt[i].id = id++;
    }
    tiltUrls.children = tilt;
    let floorCrackUrls = {
      id: id++,
      name: "地坪开裂图",
      originalName: "地坪开裂图",
      field: "floorCrack",
      children: [],
    };
    for (let i = 0; i < floorCrack.length; i++) {
      floorCrack[i].parent_name = "地坪开裂图";
      floorCrack[i].originalName = floorCrack[i].name;
      floorCrack[i].id = id++;
    }
    floorCrackUrls.children = floorCrack;
    let baseUrls = {
      id: id++,
      name: "外观图",
      originalName: "外观图",
      field: "base",
      children: [],
    };
    //基础信息照片
    let res = await engineerInfoDetail({
      project_id: store.state.cadModules.rlProject_id,
    });
    let imgs = res.data.imgs;

    for (let i = 0; i < imgs.length; i++) {
      baseUrls.children.push({
        parent_name: "外观图",
        id: id++,
        name: "图片" + Number(i + 1),
        img: imgs[i],
      });
    }

    let jpgUrls = {
      baseUrls: baseUrls,
      buildingPlaneUrls: buildingPlaneUrls,
      structurePlaneUrls: structurePlaneUrls,
      sinkUrls: sinkUrls,
      tiltUrls: tiltUrls,
      floorCrackUrls: floorCrackUrls,
    };
    //更新项目配置
    await configEdit({
      project_id: store.state.cadModules.rlProject_id,
      direction: data.direction,
      planar: jpgUrls,
      model_config: data.model_config,
    });
    //显示背景栅格
    if (gridShow) changeBackgroundGrid(true);
    // console.log("jpgUrls", jpgUrls);
    tryHideFullScreenLoading();
    return jpgUrls;
  } catch (error) {
    throw error;
  } finally {
    // 强制清理所有临时资源
    deleteCompass();
    deleteAllHatch();
    deleteOtherLines();
    // 重置全局变量
    ents = {
      rlAxis: [],
      rlGrid: [],
      // ... 其他属性重置为空数组
    };
    beforeShow = {};
  }
};
//上传建筑平面图Jpg
export const uploadBuildingPlaneJpg = async () => {
  try {
    let filePathUrls = [];
    // 串行处理每个楼层
    for (const item of store.state.globalData.rl_floor_arr) {
      try {
        //切换楼层
        await changeFloorSrd(item);
        //设置建筑平面图
        await buildingPlaneSetting(true);
        //隐藏房间的二维线段
        await showHideLine(false);
        let result = await pdfToJpg(item.Name);
        if (result != null) {
          filePathUrls.push(result);
        }
        //显示房间的二维线段
        await showHideLine(true);
        //恢复建筑平面图
        await buildingPlaneSetting(false);
      } catch (error) {
        console.error(`处理楼层 ${item.Name} 时出错:`, error);
        //恢复建筑平面图
        await buildingPlaneSetting(false);
        continue; // 继续处理下一个楼层
      }
    }
    return filePathUrls;
  } catch (error) {
    throw error;
  }
};

//上传结构平面图Jpg
export const uploadStructurePlaneJpg = async () => {
  try {
    let filePathUrls = [];
    // 串行处理每个楼层
    for (const item of store.state.globalData.rl_floor_arr) {
      try {
        //切换楼层
        await changeFloorSrd(item);
        //隐藏房间的二维线段
        await showHideLine(false);
        //设置结构平面图
        await structurePlaneSetting(true, "平面图", false);
        let result = await pdfToJpg(item.Name);
        if (result != null) {
          filePathUrls.push(result);
        }
        //显示房间的二维线段
        await showHideLine(true);
        //恢复结构平面图
        await structurePlaneSetting(false, "平面图", false);
      } catch (error) {
        console.error(`处理楼层 ${item.Name} 时出错:`, error);
        //恢复结构平面图
        await structurePlaneSetting(false, "平面图", false);
        continue; // 继续处理下一个楼层
      }
    }
    return filePathUrls;
  } catch (error) {
    throw error;
  }
};
//上传沉降测点图Jpg
export const uploadSinkJpg = async () => {
  try {
    //切换楼层
    if (store.state.globalData.rl_floor_arr.length <= 0) {
      return null;
    }
    await changeFloorSrd(store.state.globalData.rl_floor_arr[0]);
    //隐藏房间的二维线段
    await showHideLine(false);
    await structurePlaneSetting(true, "沉降测点图", false);
    // 获取沉降测点
    const { data } = await SettlementDetectionList({
      project_id: store.state.cadModules.rlProject_id,
    });
    // 绘制测点
    let svgids = [];
    if (data.siteList && data.siteList.length > 0) {
      for (const item of data.siteList) {
        // var addObj = await drawSvg(data.siteList, item.pt1, item.No_);
        // Object.assign(item, addObj);
        let text = new rlTextData();
        let pt = new McGePoint3d(item.pt1.x, item.pt1.y, item.pt1.z);
        text.position = pt;
        text.Text = item.No_ + "#";
        text.textType = "导出图纸";
        text.draw(true);
        let textObj = text.mcDbId.getMcDbEntity();
        textObj.alignmentPoint = textObj.position = pt;
        svgids.push(text.mcDbId);
      }
    }
    // 导出平面图
    let result = await pdfToJpg("1F");
    // 删除测点
    // await delMeasurePoint(data.siteList, ["svgId", "textId", "circleId"]);
    for (const item of svgids) {
      item.erase();
    }
    let results = [result];
    //显示房间的二维线段
    await showHideLine(true);
    await structurePlaneSetting(false, "沉降测点图", false);
    return results;
  } catch (error) {
    //恢复结构平面图
    await structurePlaneSetting(false, "沉降测点图", false);
    throw error;
  }
};
//上传倾斜测点图Jpg
export const uploadTiltJpg = async () => {
  try {
    // 获取倾斜测点
    const { data } = await ShearingObliqueList({
      project_id: store.state.cadModules.rlProject_id,
    });
    let filePathUrls = [];
    if (data.siteList && data.siteList.length > 0) {
      //按楼层id分组测点
      const floorSiteList = data.siteList.reduce((acc, item) => {
        const floorId = item.floorGuid;
        if (!acc[floorId]) {
          acc[floorId] = [];
        }
        acc[floorId].push(item);
        return acc;
      }, {});
      for (const floor in floorSiteList) {
        const siteList = floorSiteList[floor];
        //查找确认楼层数据是否存在
        let floorId = null;
        for (const item of store.state.globalData.rl_floor_arr) {
          if (item.Guid == floor) {
            floorId = item;
            break;
          }
        }
        if (floorId) {
          try {
            //切换楼层
            await changeFloorSrd(floorId);
            //隐藏房间的二维线段
            await showHideLine(false);
            await structurePlaneSetting(true, "倾斜测点图", false);
            let drawsiteList = []; //实际绘制的测点
            //绘制测点
            let svgids = [];
            for (const item of siteList) {
              // var addObj = await drawSvg(siteList, item.pt1, item.No_);
              // Object.assign(item, addObj);
              // drawsiteList.push(item);
              let text = new rlTextData();
              let pt = new McGePoint3d(item.pt1.x, item.pt1.y, item.pt1.z);
              text.position = pt;
              text.Text = item.No_ + "#";
              text.textType = "导出图纸";
              text.draw(true);
              let textObj = text.mcDbId.getMcDbEntity();
              textObj.alignmentPoint = textObj.position = pt;
              svgids.push(text.mcDbId);
            }
            // 导出平面图
            filePathUrls.push(await pdfToJpg(floorId.Name));
            //删除测点
            // await delMeasurePoint(drawsiteList, ["svgId", "textId", "circleId"]);
            for (const item of svgids) {
              item.erase();
            }
            //显示房间的二维线段
            await showHideLine(true);
            await structurePlaneSetting(false, "倾斜测点图", false);
          } catch (error) {
            //恢复结构平面图
            await structurePlaneSetting(false, "倾斜测点图", false);
            throw error;
          }
        }
      }
    }
    return filePathUrls;
  } catch (error) {
    throw error;
  }
};
//上传地坪开裂Jpg
export const uploadFloorCrackJpg = async () => {
  try {
    //切换楼层
    if (store.state.globalData.rl_floor_arr.length <= 0) {
      return null;
    }
    // await changeFloorSrd(store.state.globalData.rl_floor_arr[0]);
    // 获取地坪开裂
    const { data } = await SpaceList({
      project_id: store.state.cadModules.rlProject_id,
    });
    if (!data || (data.floor_cracking && data.floor_cracking.length <= 0)) {
      return null;
    }
    const floor_cracking = data.floor_cracking || [];
    let flrData = [];
    for (const item of floor_cracking) {
      let index = -1;
      let Guid = "";
      if (item.flrGuid) {
        Guid = item.flrGuid;
      } else {
        Guid = store.state.globalData.rl_floor_arr[0].Guid;
      }
      index = flrData.findIndex((flr) => flr.flrGuid == Guid);
      if (index == -1) {
        flrData.push({
          flrGuid: item.flrGuid,
          floor_cracking: [item],
        });
      } else flrData[index].floor_cracking.push(item);
    }
    let results = [];
    for (const item of flrData) {
      let flrIndex = store.state.globalData.rl_floor_arr.findIndex(
        (flr) => flr.Guid == item.flrGuid
      );
      if (flrIndex != -1) {
        await changeFloorSrd(store.state.globalData.rl_floor_arr[flrIndex]);
      } else continue;
      //隐藏房间的二维线段
      await showHideLine(false);
      await structurePlaneSetting(true, "地坪开裂图", false);
      // 绘制测点
      await drawAnyLine(item.floor_cracking);
      // 导出平面图
      let result = await pdfToJpg(
        store.state.globalData.rl_floor_arr[flrIndex].Name
      );
      // 清空画布上的裂缝数据
      await delMeasurePoint(item.floor_cracking, [
        "lineId",
        "textId",
        "circleId",
      ]);
      results.push(result);
      //显示房间的二维线段
      await showHideLine(true);
      await structurePlaneSetting(false, "地坪开裂图", false);
    }
    return results;
  } catch (error) {
    //恢复结构平面图
    await structurePlaneSetting(false, "地坪开裂图", false);
    throw error;
  }
};
//导出DWG
export const exportDwg = async (fileName) => {
  try {
    const mxcad = MxCpp.getCurrentMxCAD();
    return new Promise((resolve, reject) => {
      mxcad.saveFileToUrl(sSaveProgramUrl, async (iResult, sserverResult) => {
        try {
          console.log("sserverResult", sserverResult);
          if (sserverResult) {
            let ret = JSON.parse(sserverResult);
            if (ret.ret == "ok") {
              let filePath = baseUrl + saveDwgUrl + ret.file;
              resolve({
                url: filePath,
                name: fileName,
              });
            } else {
              console.log("导出平面图error", ret);
              reject(new Error("导出失败"));
            }
          } else {
            console.log("导出平面图error", ret);
            reject(new Error("导出失败"));
          }
        } catch (error) {
          console.log("导出平面图error", error);
          reject(error);
        }
      });
    });
  } catch (error) {
    console.log("导出平面图error", error);
    return null;
  }
};
//文件打包--zip
export const zipFile = async (filePathUrls, fileType) => {
  if (filePathUrls.length > 0) {
    const zip = new JSZip();
    // 创建文件夹
    const folder = zip.folder(store.state.cadModules.rlProject_name + fileType);

    // 下载网络文件并添加到ZIP文件夹中
    Promise.all(
      filePathUrls.map((file) =>
        fetch(file.url)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`下载失败: ${file.url}`);
            }
            return res.blob();
          })
          .then((blob) => {
            folder.file(file.name, blob);
          })
      )
    )
      .then(() => {
        // 所有文件添加完成，生成ZIP
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(
            content,
            store.state.cadModules.rlProject_name + fileType + ".zip"
          );
        });
      })
      .catch((error) => {
        console.error("下载过程中出现错误:", error);
      });
  }
};
// 添加 exportPdf 方法
export const exportPdf = async () => {
  try {
    const mxcad = MxCpp.getCurrentMxCAD();
    return new Promise((resolve, reject) => {
      let param = {
        width: "2100",
        height: "2970",
      };
      mxcad.saveFileToUrl(
        sSaveProgramPdfUrl,
        async (iResult, sserverResult) => {
          try {
            console.log("sserverResult", sserverResult);
            let ret = JSON.parse(sserverResult);
            if (ret.ret == "ok") {
              let filePath = baseUrl + saveDwgUrl + ret.file;
              resolve(filePath);
            } else {
              reject(new Error("导出失败"));
            }
          } catch (error) {
            console.log("error", error);
            reject(error);
          }
        },
        "",
        JSON.stringify(param)
      );
    });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

//显示隐藏房间的二维线段
export const showHideLine = async (showType) => {
  try {
    //隐藏房间的二维线段
    const allUse = store.state.rlEntData.totalEntityData["rlUse"];
    for (const item of allUse) {
      if (item.mcDbId) {
        item.mcDbId.getMcDbEntity().visible = showType;
      }
    }
    //隐藏节点二维线段
    const allNode = store.state.rlEntData.totalEntityData["rlJoint"];
    for (const item of allNode) {
      if (item.mcDbCircleIds) {
        for (const circle of item.mcDbCircleIds) {
          circle.getMcDbEntity().visible = showType;
        }
      }
    }
    let isShowText = getCheckStatus(18); //是否显示了截面尺寸文字
    if (isShowText) {
      //把楼板的截面文字进行修改
      const slabData = store.state.rlEntData.totalEntityData["rlSlab"];
      for (const slab of slabData) {
        if (slab.m_TextObj) {
          if (!showType) {
            slab.m_TextObj.mcDbId.getMcDbEntity().textString =
              "h=" + slab.m_sectGroupName;
          } else {
            slab.m_TextObj.mcDbId.getMcDbEntity().textString =
              slab.m_sectGroupName;
          }
        }
      }
    }
    // 更新显示
    rlAppObj.rlMxDrawObject.updateDisplay();
  } catch (error) {
    throw error;
  }
};

//根据guid获取checkbox的点击状态
export const getCheckStatus = (guid) => {
  return store.state.displayData.rlLayerDisplay.includes(guid);
};

//绘制指北针
export const drawCompass = async () => {
  const allJoint = store.state.rlEntData.totalEntityData["rlJoint"];
  let box = new THREE.Box3();
  for (const item of allJoint) {
    box.expandByPoint(new McGePoint3d(...item.m_pt));
  }
  let rightTopPt = new McGePoint3d(box.min.x - 4500, box.max.y + 4500, 0);
  const mxcad = MxCpp.getCurrentMxCAD();
  let circle = mxcad.drawCircle(rightTopPt.x, rightTopPt.y, 2500);
  compassId.push(circle);
  const objCircle = circle.getMcDbEntity();
  let circleCenter = objCircle.center;
  let res = await projectConfig({
    project_id: store.state.cadModules.rlProject_id,
  });
  let rotationAngle = 0;
  if (res.data.direction && res.data.direction.length) {
    rotationAngle = res.data.direction[0];
  }
  let directionPoint = getDirectionPoint(circleCenter, rotationAngle, 1);
  let vec1 = new THREE.Vector3(
    directionPoint.x,
    directionPoint.y,
    0
  ).normalize();
  console.log("vec1", vec1);

  let vec = new THREE.Vector3()
    .subVectors(directionPoint, circleCenter)
    .normalize();
  let vec2 = new THREE.Vector3(-vec.x, -vec.y, 0);
  let pt1 = new McGePoint3d(directionPoint.x, directionPoint.y, 0);
  let pt2 = MovePt(pt1, vec, 2000);
  let pt3 = MovePt(pt1, vec, 3000); //文字插入点
  if (rotationAngle > 90 && rotationAngle < 270) {
    pt3.y -= 400;
  }
  pt1 = MovePt(pt1, vec2, 2000);
  let line = mxcad.drawLine(pt1.x, pt1.y, pt2.x, pt2.y);
  compassId.push(line);
  let { left, right } = getArrowWingPoints(pt1, pt2, 1000, 30);
  let line1 = mxcad.drawLine(left.x, left.y, pt2.x, pt2.y);
  let line2 = mxcad.drawLine(right.x, right.y, pt2.x, pt2.y);
  let line3 = mxcad.drawLine(left.x, left.y, right.x, right.y);
  compassId.push(line1);
  compassId.push(line2);
  compassId.push(line3);
  let text = mxcad.drawText(pt3.x, pt3.y, "北", 1000, 0, 1, 0);
  compassId.push(text);
};
export const getDirectionPoint = (center, angle, radius) => {
  // 角度转弧度
  const rad = (angle * Math.PI) / 180;
  return {
    x: center.x + radius * Math.sin(rad), // x用sin
    y: center.y + radius * Math.cos(rad), // y用cos
  };
};
/**
 * 计算箭头两侧点
 * @param {Object} pt1 起点 {x, y}
 * @param {Object} pt2 终点/箭头尖 {x, y}
 * @param {number} arrowLength 箭头长度
 * @param {number} arrowAngle 箭头夹角（度）
 * @returns {Object} {left, right} 两个点
 */
export const getArrowWingPoints = (
  pt1,
  pt2,
  arrowLength = 20,
  arrowAngle = 30
) => {
  const dx = pt2.x - pt1.x;
  const dy = pt2.y - pt1.y;
  const angle = Math.atan2(dy, dx);

  // 箭头两侧的角度
  const angle1 = angle + Math.PI - (Math.PI * arrowAngle) / 180;
  const angle2 = angle + Math.PI + (Math.PI * arrowAngle) / 180;

  // 箭头两侧点
  const left = new McGePoint3d(
    pt2.x + arrowLength * Math.cos(angle1),
    pt2.y + arrowLength * Math.sin(angle1),
    0
  );
  const right = new McGePoint3d(
    pt2.x + arrowLength * Math.cos(angle2),
    pt2.y + arrowLength * Math.sin(angle2),
    0
  );

  return { left, right };
};
//删除指北针
export const deleteCompass = () => {
  compassId.forEach((id) => {
    id.getMcDbEntity().erase();
  });
  compassId = [];
  // 强制触发垃圾回收（浏览器非标准，但部分浏览器支持）
  if (window.gc) window.gc();
};

/**
 * 去掉中间共线点，只保留转折点（含首尾点）
 * @param {Array} points 点集，格式为 [McGePoint3d, ...]
 * @returns {Array} 只含转折点的点集
 */
export const getCornerPoints = (points) => {
  if (points.length <= 2) return points.slice();

  const result = [];
  for (let i = 0; i < points.length; i++) {
    let pervIndex = i - 1;
    if (pervIndex < 0) pervIndex = points.length - 1;
    let nextIndex = i + 1;
    if (nextIndex >= points.length) nextIndex = 0;
    const prev = points[pervIndex];
    const curr = points[i];
    const next = points[nextIndex];

    // 只判断x、y
    const v1x = curr.x - prev.x,
      v1y = curr.y - prev.y;
    const v2x = next.x - curr.x,
      v2y = next.y - curr.y;
    const cross = v1x * v2y - v1y * v2x;
    if (Math.abs(cross) > 1e-8) {
      result.push(curr);
    }
  }
  // result.push(points[points.length - 1]);
  return result;
};

//墙/柱增加填充
export const addFillToWallAndColumn = async () => {
  //砼填充
  const drawHatchConcrete = (pts) => {
    const mxcad = MxCpp.getCurrentMxCAD();
    //斜线填充
    const hatch1 = new McDbHatch();
    hatch1.appendLoop(new McGePoint3dArray(pts));
    // 清除填充图案效果
    hatch1.clearPatternDefinition();
    // 添加图案填充定义
    hatch1.addPatternDefinition(
      45,
      1,
      1,
      1,
      200, // 这里改成1，间隔就比0.25大很多
      [45, 0.17677695, 0, 0, 1, 0.125, -0.0625]
    );
    // 设置填充图案
    hatch1.setPattern(McDb.HatchPatternType.kCustomDefined, "test");
    // 设置填充颜色
    hatch1.trueColor = new McCmColor(0, 0, 0);
    // 绘制填充对象
    allHatchId.push(MxCpp.getCurrentMxCAD().drawEntity(hatch1));
    mxcad.addPatternDefinition(
      "MyHatchPattern1",
      "((50, 0, 0, 4.12975034, -5.89789472, 0.75, -8.25))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern1";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    mxcad.drawColor = new McCmColor(0, 0, 0);
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern2",
      "((355, 0, 0, -2.03781207, 7.3723684, 0.6, -6.6))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern2";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern3",
      "((100.45144446, 0.59771681, -0.05229344, 5.7305871, -6.9397673, 0.63740192, -7.01142112))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern3";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern4",
      "((46.1842, 0, 2, 6.19462554, -8.84684596, 1.125, -12.375))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern4";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern5",
      "((96.63563549, 0.88936745, 1.86206693, 8.59588239, -10.40964966, 0.95610342, -10.5171376))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern5";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern6",
      "((351.18416399, 0, 2, 7.74327494, 11.05855746, 0.9, -9.90000001))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern6";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern7",
      "((21, 1, 1.5, 4.12975034, -5.89789472, 0.75, -8.25))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern7";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern8",
      "((326, 1, 1.5, -2.03781207, 7.3723684, 0.6, -6.6))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern8";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern9",
      "((71.45144474, 1.49742254, 1.16448426, 5.7305871, -6.9397673, 0.6374019, -7.01142112))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern9";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern10",
      "((37.5, 0, 0, 2.123, 2.567, 0, -6.52, 0, -6.7, 0, -6.625))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern10";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern11",
      "((7.5, 0, 0, 3.123, 3.567, 0, -3.82, 0, -6.37, 0, -2.525))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern11";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern12",
      "((-32.5, -2.23, 0, 4.6234, 2.678, 0, -2.5, 0, -7.8, 0, -10.35))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern12";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 0, 0, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(20));
    mxcad.addPatternDefinition(
      "MyHatchPattern13",
      "((-42.5, -3.23, 0, 3.6234, 4.678, 0, -3.25, 0, -5.18, 0, -7.35))"
    );
    mxcad.drawPatternDefinition = "MyHatchPattern13";
    //定义一个路径的开始点
    mxcad.pathMoveToEx(pts[0].x, pts[0].y, 10, 10, 0.3);
    for (let h = 0; h < pts.length; h++) {
      //路径的一下个点
      mxcad.pathLineTo(pts[h].x, pts[h].y);
    }
    //把路径变成一个填充,80,是填充图案的缩放比例.
    allHatchId.push(mxcad.drawPathToHatch(10));
    const hatchLayer = mxcad.addLayer("填充层");
    for (const item of allHatchId) {
      item.getMcDbEntity().layerId = hatchLayer;
    }
  };
  //砖填充
  const drawHatchBrick = (pts) => {
    const mxcad = MxCpp.getCurrentMxCAD();
    //斜线填充
    const hatch1 = new McDbHatch();
    hatch1.appendLoop(new McGePoint3dArray(pts));
    // 清除填充图案效果
    hatch1.clearPatternDefinition();
    // 添加图案填充定义
    hatch1.addPatternDefinition(
      45,
      1,
      1,
      1,
      200,
      [45, 0.17677695, 0, 0, 0.25, 0.125, -0.0625]
    );
    // 设置填充图案
    hatch1.setPattern(McDb.HatchPatternType.kCustomDefined, "test");
    // 设置填充颜色
    hatch1.trueColor = new McCmColor(0, 0, 0);
    // 绘制填充对象
    allHatchId.push(MxCpp.getCurrentMxCAD().drawEntity(hatch1));
    const hatchLayer = mxcad.addLayer("填充层");
    for (const item of allHatchId) {
      item.getMcDbEntity().layerId = hatchLayer;
    }
  };
  //柱子填充填充颜色-白色 俏宇提的
  const drawHatchColumn = (pts) => {
    const mxcad = MxCpp.getCurrentMxCAD();

    const hatch1 = new McDbHatch();
    hatch1.appendLoop(new McGePoint3dArray(pts));
    // 清除填充图案效果
    hatch1.clearPatternDefinition();
    // 添加图案填充定义
    hatch1.addPatternDefinition(
      45,
      1,
      1,
      1,
      0.25,
      [45, 0.17677695, 0, 0, 0.25, 0.125, -0.0625]
    );
    // 设置填充图案
    hatch1.setPattern(McDb.HatchPatternType.kCustomDefined, "test");
    // 设置填充颜色
    hatch1.trueColor = new McCmColor(255, 255, 255);
    // 绘制填充对象
    allHatchId.push(MxCpp.getCurrentMxCAD().drawEntity(hatch1));
  };
  for (const item of ents.rlColSeg) {
    let pts = [];
    for (let i = 0; i < item.index2dData.length; i += 3) {
      pts.push(
        new McGePoint3d(
          item.index2dData[i],
          item.index2dData[i + 1],
          item.index2dData[i + 2]
        )
      );
    }
    pts.push(pts[0]);
    //如果材质是6，则绘制填充,砼
    if (item.m_sectParamData && item.m_sectParamData.Mat == 6)
      await drawHatchColumn(pts);
  }
  for (const item of ents.rlWallSeg) {
    let pts = [];
    if (!item.m_HoleId) {
      let templatePts = [];
      if (!item.index2dData) {
        continue;
      }
      for (let i = 0; i < item.index2dData.length; i += 3) {
        templatePts.push(
          new McGePoint3d(
            item.index2dData[i],
            item.index2dData[i + 1],
            item.index2dData[i + 2]
          )
        );
      }
      templatePts.push(templatePts[0]);
      pts.push(templatePts);
    } else {
      for (let s = 0; s < item.otherDrawIds.length; s++) {
        let polyline = item.otherDrawIds[s].getMcDbEntity();
        if (!polyline) continue;
        let num = polyline.numVerts();
        let templatePts = [];
        for (let i = 0; i < num; i++) {
          let pt = polyline.getPointAt(i).val;
          templatePts.push(new McGePoint3d(pt.x, pt.y, pt.z));
        }
        templatePts.push(templatePts[0]);
        pts.push(templatePts);
      }
    }

    //如果材质是6，则绘制填充,砼
    if (item.m_sectParamData) {
      if (item.m_sectParamData.Mat == 6) {
        for (const templatePts of pts) {
          await drawHatchConcrete(templatePts);
        }
      } else {
        for (const templatePts of pts) {
          await drawHatchBrick(templatePts);
        }
      }
    }
  }
  rlAppObj._rlMx.MxFun.updateDisplay();
  rlAppObj.rlMxDrawObject.updateDisplay();
};
//删除所有填充
export const deleteAllHatch = () => {
  allHatchId.forEach((id) => {
    id.getMcDbEntity().erase();
  });
  allHatchId = [];
  if (window.gc) window.gc();
};

//更新实体数据
export const updateEntityData = () => {
  ents.rlAxis = store.state.rlEntData.totalEntityData["rlAxis"];
  ents.rlGrid = store.state.rlEntData.totalEntityData["rlGrid"];
  ents.rlColSeg = store.state.rlEntData.totalEntityData["rlColSeg"];
  ents.rlBeamSeg = store.state.rlEntData.totalEntityData["rlBeamSeg"];
  ents.rlWallSeg = store.state.rlEntData.totalEntityData["rlWallSeg"];
  ents.rlSlab = store.state.rlEntData.totalEntityData["rlSlab"];
  ents.rlSlabHole = store.state.rlEntData.totalEntityData["rlSlabHole"];
  ents.rlCantiSlab = store.state.rlEntData.totalEntityData["rlCantiSlab"];
  ents.rlSubBeam = store.state.rlEntData.totalEntityData["rlSubBeam"];
  ents.rlWallHole = store.state.rlEntData.totalEntityData["rlWallHole"];
  ents.rlModelNo = store.state.rlEntData.totalEntityData["rlModelNo"];
  ents.rlText = store.state.rlEntData.totalEntityData["rlText"];
  ents.rlPartitionWallSeg =
    store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
  ents.rlDoors = [];
  ents.rlWindows = [];
  ents.rlUse = store.state.rlEntData.totalEntityData["rlUse"];
  //归类墙洞
  if (
    ents.rlWallHole &&
    Array.isArray(ents.rlWallHole) &&
    ents.rlWallHole.length > 0
  ) {
    let wallHoles = ents.rlWallHole;
    ents.rlWallHole = [];
    for (const item of wallHoles) {
      if (item && item.doorsWindowsType !== undefined) {
        if (item.doorsWindowsType == 0) {
          ents.rlWindows.push(item);
        } else if (item.doorsWindowsType == 1) {
          ents.rlDoors.push(item);
        } else {
          ents.rlWallHole.push(item);
        }
      }
    }
  }
};

// 设置模块显示与隐藏
export const setVisible = async (arr, bol) => {
  const isCheckSectSize = getCheckStatus(18);
  const isCheckModelNo = getCheckStatus(11);
  let toggleAxisDistExecuted = false; // 标志变量，用于判断是否执行过 toggleAxisDist 函数
  const isCheckCheckText = getCheckStatus(25); //用与现实控制文字

  if (arr.length > 0) {
    arr.forEach(async (m) => {
      if (m.classTypeName == "rlAxis") {
        // 轴线显示隐藏
        m.calAxisNameData(bol);
        store.commit("platBtns/SET_AXISISISSHOW", bol);

        // 轴线距离显示隐藏，只执行一次
        if (!toggleAxisDistExecuted) {
          toggleAxisDist(bol);
          toggleAxisDistExecuted = true; // 标志变量设为 true
        }
      } else if (m && m.mcDbId) {
        if (m.classTypeName == "rlText" && m.textType == "配筋数据文字") {
          return;
        } else {
          m.mcDbId.getMcDbEntity().visible = bol;
        }
      }
      if (m && m.mcDbId && m.classTypeName != "rlAxis") {
        const objTmp = m.mcDbId.getMcDbEntity();
        // 若截面尺寸所属的构件隐藏，则截面尺寸也隐藏
        if (bol && m.belongObjId) {
          const belongObj = m.belongObjId.getMcDbEntity();
          if (belongObj.visible == false) {
            objTmp.visible = false;
            return;
          }
        }
        objTmp.visible = bol;
      }

      // 配筋数据文字跟随构件显隐
      if (m.m_HomogeneousData && m.m_HomogeneousData.length > 0) {
        for (let i = 0; i < m.m_HomogeneousData.length; i++) {
          m.m_HomogeneousData[i].getMcDbEntity().visible = bol;
        }
      }
      //检查构件文字跟随构件显隐
      if (m.classTypeName == "rlWallSeg" || m.classTypeName == "rlBeamSeg") {
        if (isCheckCheckText) {
          m.m_gridData.drawCheckText();
        }
      } else {
        if (isCheckCheckText && m.checkText) {
          m.checkText.getMcDbEntity().visible = bol;
        }
      }

      // 文字对象跟随构件显隐
      if (m.Attribute || m.classTypeName == "rlUse") {
        if (m.m_TextObj && m.m_TextObj.mcDbId) {
          if (bol && m.classTypeName != "rlUse") {
            m.m_TextObj.mcDbId.getMcDbEntity().visible = isCheckSectSize;
            if (m.ModelNoTextObj && m.ModelNoTextObj.mcDbId) {
              m.ModelNoTextObj.mcDbId.getMcDbEntity().visible = isCheckModelNo;
            }
          } else {
            m.m_TextObj.mcDbId.getMcDbEntity().visible = bol;
            if (m.ModelNoTextObj && m.ModelNoTextObj.mcDbId) {
              m.ModelNoTextObj.mcDbId.getMcDbEntity().visible = bol;
            }
          }
        }

        // m.mcDbId.getMcDbEntity().visible = bol;
        // m.m_TextObj.setNeedUpdateDisplay(true);
      }
      if (m.classTypeName == "rlDoorsWindows" && m.otherDrawIds.length > 0) {
        // 门窗的填充线跟随门窗显隐
        m.otherDrawIds.forEach((item) => {
          item.getMcDbEntity().visible = bol;
        });
      } else if (
        m.classTypeName == "rlPartitionWallSeg" &&
        m.otherDrawIds.length > 0
      ) {
        // 门窗的填充线跟随门窗显隐
        m.otherDrawIds.forEach((item) => {
          item.getMcDbEntity().visible = bol;
        });
        // 当隔墙打断时，隔墙线显示隐藏
        m.mcDbId.getMcDbEntity().visible = false;
      } else if (m.classTypeName == "rlWallHole" && m.otherDrawIds.length > 0) {
        // 门窗的填充线跟随门窗显隐
        m.otherDrawIds.forEach((item) => {
          item.getMcDbEntity().visible = bol;
        });

        if (m.doorsWindowsType == 1) {
          m.mcDbId.getMcDbEntity().visible = false;
        }
      } else if (m.classTypeName == "rlWallSeg" && m.otherDrawIds.length > 0) {
        // 门窗的填充线跟随门窗显隐
        m.otherDrawIds.forEach((item) => {
          item.getMcDbEntity().visible = bol;
        });
        // 当隔墙打断时，隔墙线显示隐藏
        m.mcDbId.getMcDbEntity().visible = false;
      }
    });
    rlAppObj._rlMx.MxFun.updateDisplay();
    rlAppObj.rlMxDrawObject.updateDisplay();
  }
};

//显示隐藏建筑构件
export const showHideBuildingComponent = async (isShow) => {
  updateEntityData();
  await hideAllComponent();
  if (isShow) {
    setVisible(ents.rlColSeg, true);
    setVisible(ents.rlWallSeg, true);
    setVisible(ents.rlPartitionWallSeg, true);
    setVisible(ents.rlDoors, true);
    setVisible(ents.rlWindows, true);
    setVisible(ents.rlUse, true);
    setVisible(ents.rlAxis, true);
    rlAppObj._rlMx.MxFun.updateDisplay();
    rlAppObj.rlMxDrawObject.updateDisplay();
  } else {
    await restoreComponent();
  }
};

//显示隐藏结构构件
export const showHideStructureComponent = async (
  isShow,
  type = "平面图",
  isDwg = true
) => {
  updateEntityData();
  await hideAllComponent();
  if (isShow) {
    setVisible(ents.rlColSeg, true);
    setVisible(ents.rlWallSeg, true);
    setVisible(ents.rlSlabHole, true);
    setVisible(ents.rlSubBeam, true);
    let isWallHoleArr = [];
    for (const item of ents.rlWallHole) {
      if (item.doorsWindowsType == 1) {
        isWallHoleArr.push(item);
      }
    }
    setVisible(isWallHoleArr, true);
    if (type == "平面图") {
      setVisible(ents.rlAxis, true);
      const slabData = ents.rlSlab;
      if (isDwg) {
        const mxcad = MxCpp.getCurrentMxCAD();
        const wallSizeLayer = mxcad.addLayer("墙厚标注");
        const slabSizeLayer = mxcad.addLayer("板厚标注");
        const colSizeLayer = mxcad.addLayer("柱尺寸标注");
        const beamSizeLayer = mxcad.addLayer("梁尺寸标注");
        for (const item of ents.rlColSeg) {
          let text = item.m_TextObj.mcDbId.getMcDbEntity().clone();
          text.visible = true;
          text.layerId = colSizeLayer;
          let drawEntity = rlAppObj.mxcadObject.drawEntity(text);
          otherLineId.push(drawEntity);
        }
        for (const item of ents.rlWallSeg) {
          let text = item.m_TextObj.mcDbId.getMcDbEntity().clone();
          text.visible = true;
          text.layerId = wallSizeLayer;
          let drawEntity = rlAppObj.mxcadObject.drawEntity(text);
          otherLineId.push(drawEntity);
        }
        for (const item of ents.rlBeamSeg) {
          let text = item.m_TextObj.mcDbId.getMcDbEntity().clone();
          text.visible = true;
          text.layerId = beamSizeLayer;
          let drawEntity = rlAppObj.mxcadObject.drawEntity(text);
          otherLineId.push(drawEntity);
        }
        for (const item of ents.rlSlab) {
          let text = item.m_TextObj.mcDbId.getMcDbEntity().clone();
          text.visible = true;
          text.textString = "h=" + item.m_sectGroupName;
          if (item.RoomIsHole == 1) text.textString = "h=0";
          text.layerId = slabSizeLayer;
          let drawEntity = rlAppObj.mxcadObject.drawEntity(text);
          otherLineId.push(drawEntity);
        }
      }
    }
    const mxcad = MxCpp.getCurrentMxCAD();
    // 设置虚线类型
    mxcad.addLinetype("MyLineType", "50,-50");
    for (const item of ents.rlDoors) {
      if (item.m_gridData.classTypeName != "rlGrid") continue;
      let clone = item.mcDbId.getMcDbEntity().clone();
      clone.trueColor = new McCmColor(255, 255, 255);
      //设置虚线
      clone.visible = true;
      let drawEntity = rlAppObj.mxcadObject.drawEntity(clone);
      const obj = drawEntity.getMcDbEntity();
      obj.linetype = "MyLineType";
      otherLineId.push(drawEntity);
    }
    for (const item of ents.rlWindows) {
      if (item.m_gridData.classTypeName != "rlGrid") continue;
      let clone = item.mcDbId.getMcDbEntity().clone();
      clone.trueColor = new McCmColor(255, 255, 255);
      clone.visible = true;
      let drawEntity = rlAppObj.mxcadObject.drawEntity(clone);
      const obj = drawEntity.getMcDbEntity();
      obj.linetype = "MyLineType";
      otherLineId.push(drawEntity);
    }
    //板洞线
    const slabHoleLayer = mxcad.addLayer("板洞(折线)");
    for (const item of ents.rlSlabHole) {
      let box = new THREE.Box3();
      for (let i = 0; i < item.index2dData.length; i += 3) {
        box.expandByPoint(
          new McGePoint3d(
            item.index2dData[i],
            item.index2dData[i + 1],
            item.index2dData[i + 2]
          )
        );
      }
      let minPt = box.min;
      let maxPt = box.max;
      let width = Math.abs(maxPt.x - minPt.x);
      let height = Math.abs(maxPt.y - minPt.y);
      let addY = (height / 3) * 2;
      let addX = width / 5;
      let pt = new McGePoint3d(minPt.x + addX, minPt.y + addY, minPt.z);
      let line1 = mxcad.drawLine(minPt.x, minPt.y, pt.x, pt.y);
      line1.getMcDbEntity().layerId = slabHoleLayer;
      otherLineId.push(line1);
      let line2 = mxcad.drawLine(pt.x, pt.y, maxPt.x, maxPt.y);
      line2.getMcDbEntity().layerId = slabHoleLayer;
      otherLineId.push(line2);
    }
    //0板
    const slabHoleLayer1 = mxcad.addLayer("板洞");
    for (const item of ents.rlSlab) {
      if (item.m_sectParamData.Thickness == 0) {
        let pts = [];
        for (let i = 0; i < item.index2dData.length; i += 3) {
          pts.push(
            new McGePoint3d(
              item.index2dData[i],
              item.index2dData[i + 1],
              item.index2dData[i + 2]
            )
          );
        }
        pts = getCornerPoints(pts);
        if (pts.length == 4) {
          let line1 = mxcad.drawLine(pts[0].x, pts[0].y, pts[2].x, pts[2].y);
          line1.getMcDbEntity().layerId = slabHoleLayer1;
          otherLineId.push(line1);
          let line2 = mxcad.drawLine(pts[1].x, pts[1].y, pts[3].x, pts[3].y);
          line2.getMcDbEntity().layerId = slabHoleLayer1;
          otherLineId.push(line2);
        }
      } else if (item.RoomIsHole == 1) {
        let box = new THREE.Box3();
        for (let i = 0; i < item.index2dData.length; i += 3) {
          box.expandByPoint(
            new McGePoint3d(
              item.index2dData[i],
              item.index2dData[i + 1],
              item.index2dData[i + 2]
            )
          );
        }
        let minPt = box.min;
        let maxPt = box.max;
        let width = Math.abs(maxPt.x - minPt.x);
        let height = Math.abs(maxPt.y - minPt.y);
        let addY = (height / 3) * 2;
        let addX = width / 5;
        let pt = new McGePoint3d(minPt.x + addX, minPt.y + addY, minPt.z);
        let line1 = mxcad.drawLine(minPt.x, minPt.y, pt.x, pt.y);
        line1.getMcDbEntity().layerId = slabHoleLayer;
        otherLineId.push(line1);
        let line2 = mxcad.drawLine(pt.x, pt.y, maxPt.x, maxPt.y);
        line2.getMcDbEntity().layerId = slabHoleLayer;
        otherLineId.push(line2);
      }
    }
  } else {
    for (const item of otherLineId) {
      item.getMcDbEntity().erase();
    }
    otherLineId = [];
    await restoreComponent();
  }
};
export const deleteOtherLines = () => {
  if (otherLineId.length === 0) return;
  otherLineId.forEach((id) => {
    try {
      const entity = id.getMcDbEntity();
      if (entity && !entity.isErased()) {
        entity.erase();
      }
      id = null;
    } catch (error) {
      console.error("删除其他线段失败：", error);
    }
  });
  otherLineId = [];
  if (window.gc) window.gc();
};
//设置建筑构件的图层
export const setBuildingComponentLayer = () => {
  updateEntityData();
  const mxcad = MxCpp.getCurrentMxCAD();
  const colLayer = mxcad.addLayer("柱");
  const wallLayer = mxcad.addLayer("墙");
  const partitionWallLayer = mxcad.addLayer("隔墙");
  const doorLayer = mxcad.addLayer("门");
  const windowLayer = mxcad.addLayer("窗");
  const useLayer = mxcad.addLayer("用途");
  const axisLineLayer = mxcad.addLayer("轴线");
  const axisNoLayer = mxcad.addLayer("轴号");
  for (const item of ents.rlColSeg) {
    item.mcDbId.getMcDbEntity().layerId = colLayer;
  }
  for (const item of ents.rlWallSeg) {
    item.mcDbId.getMcDbEntity().layerId = wallLayer;
  }
  for (const item of ents.rlPartitionWallSeg) {
    item.mcDbId.getMcDbEntity().layerId = partitionWallLayer;
  }
  for (const item of ents.rlDoors) {
    for (const item1 of item.otherDrawIds) {
      item1.getMcDbEntity().layerId = doorLayer;
    }
  }
  for (const item of ents.rlWindows) {
    item.mcDbId.getMcDbEntity().layerId = windowLayer;
    for (const item1 of item.otherDrawIds) {
      item1.getMcDbEntity().layerId = windowLayer;
    }
  }
  for (const item of ents.rlUse) {
    item.m_TextObj.mcDbId.getMcDbEntity().layerId = useLayer;
  }
  for (const item of ents.rlAxis) {
    item.m_edLineTmp.mcDbId.getMcDbEntity().layerId = axisLineLayer;
    item.m_stLineTmp.mcDbId.getMcDbEntity().layerId = axisLineLayer;
    item.m_stCircle.mcDbId.getMcDbEntity().layerId = axisLineLayer;
    item.m_edCircle.mcDbId.getMcDbEntity().layerId = axisLineLayer;
    item.m_stText.mcDbId.getMcDbEntity().layerId = axisNoLayer;
    item.m_edText.mcDbId.getMcDbEntity().layerId = axisNoLayer;
  }
};

// 设置结构构件的图层
export const setStructureComponentLayer = () => {
  updateEntityData();
  const mxcad = MxCpp.getCurrentMxCAD();
  const colLayer = mxcad.addLayer("柱");
  const wallLayer = mxcad.addLayer("墙");
  const doorLayer = mxcad.addLayer("门");
  const windowLayer = mxcad.addLayer("窗");
  const useLayer = mxcad.addLayer("用途");
  const axisLineLayer = mxcad.addLayer("轴线");
  const axisNoLayer = mxcad.addLayer("轴号");
  const wallSizeLayer = mxcad.addLayer("墙厚标注");
  const slabSizeLayer = mxcad.addLayer("板厚标注");
  const colSizeLayer = mxcad.addLayer("柱尺寸标注");
  const beamSizeLayer = mxcad.addLayer("梁尺寸标注");
  const slabHoleLayer = mxcad.addLayer("板洞(折线)");
  for (const item of ents.rlColSeg) {
    item.mcDbId.getMcDbEntity().layerId = colLayer;
    item.m_TextObj.mcDbId.getMcDbEntity().layerId = colSizeLayer;
  }
  for (const item of ents.rlWallSeg) {
    item.mcDbId.getMcDbEntity().layerId = wallLayer;
    item.m_TextObj.mcDbId.getMcDbEntity().layerId = wallSizeLayer;
  }
  for (const item of ents.rlBeamSeg) {
    item.m_TextObj.mcDbId.getMcDbEntity().layerId = beamSizeLayer;
  }
  for (const item of ents.rlSlab) {
    item.m_TextObj.mcDbId.getMcDbEntity().layerId = slabSizeLayer;
  }
  for (const item of ents.rlSlabHole) {
    item.mcDbId.getMcDbEntity().layerId = slabHoleLayer;
  }
  for (const item of ents.rlDoors) {
    for (const item1 of item.otherDrawIds) {
      item1.getMcDbEntity().layerId = doorLayer;
    }
  }
  for (const item of ents.rlWindows) {
    item.mcDbId.getMcDbEntity().layerId = windowLayer;
    for (const item1 of item.otherDrawIds) {
      item1.getMcDbEntity().layerId = windowLayer;
    }
  }
  for (const item of ents.rlUse) {
    item.m_TextObj.mcDbId.getMcDbEntity().layerId = useLayer;
  }
  for (const item of ents.rlAxis) {
    item.m_edLineTmp.mcDbId.getMcDbEntity().layerId = axisLineLayer;
    item.m_stLineTmp.mcDbId.getMcDbEntity().layerId = axisLineLayer;
    item.m_stCircle.mcDbId.getMcDbEntity().layerId = axisLineLayer;
    item.m_edCircle.mcDbId.getMcDbEntity().layerId = axisLineLayer;
    item.m_stText.mcDbId.getMcDbEntity().layerId = axisNoLayer;
    item.m_edText.mcDbId.getMcDbEntity().layerId = axisNoLayer;
  }
};

//绘制梁线
export const drawBeamLine = () => {
  const mxcad = MxCpp.getCurrentMxCAD();
  const beamLineLayer1 = mxcad.addLayer("梁实线");
  const beamLineLayer2 = mxcad.addLayer("梁虚线");
  let slabPolyLines = [];
  let zeroSlabPolyLines = [];
  let beamLongLines = [];
  let beamShortLines = [];
  for (const item of ents.rlSlab) {
    let pts = [];
    for (let i = 0; i < item.index2dData.length; i += 3) {
      pts.push(
        new McGePoint3d(
          item.index2dData[i],
          item.index2dData[i + 1],
          item.index2dData[i + 2]
        )
      );
    }
    if (item.m_sectParamData.Thickness == 0 || item.RoomIsHole == 1) {
      zeroSlabPolyLines.push(pts);
    } else {
      slabPolyLines.push(pts);
    }
  }
  let beamLines1 = []; //梁实线
  let beamLines2 = []; //梁虚线
  let arcBeamLines = []; //弧梁
  for (const item of ents.rlBeamSeg) {
    let pts = [];
    for (let i = 0; i < item.index2dData.length; i += 3) {
      pts.push(
        new McGePoint3d(
          item.index2dData[i],
          item.index2dData[i + 1],
          item.index2dData[i + 2]
        )
      );
    }
    if (pts.length == 4) {
      let dist1 = pts[0].distanceTo(pts[1]);
      let dist2 = pts[1].distanceTo(pts[2]);
      if (dist1 > dist2) {
        beamLongLines.push([pts[0], pts[1]]);
        beamLongLines.push([pts[2], pts[3]]);
        beamShortLines.push([pts[1], pts[2]]);
        beamShortLines.push([pts[3], pts[0]]);
      } else {
        beamLongLines.push([pts[1], pts[2]]);
        beamLongLines.push([pts[3], pts[0]]);
        beamShortLines.push([pts[0], pts[1]]);
        beamShortLines.push([pts[2], pts[3]]);
      }
    } else {
      arcBeamLines.push({
        pts: pts,
        midPoint1: new McGePoint3d(...item.m_gridData.m_stJoint.m_pt),
        midPoint2: new McGePoint3d(...item.m_gridData.m_edJoint.m_pt),
      });
    }
  }

  // Draw arc beams with line splitting based on provided midpoints
  let arcLines1 = [];
  let arcLines2 = [];
  for (const arcBeam of arcBeamLines) {
    // 获取弧形数据和分割点
    const arcPoints = arcBeam.pts;
    const midPoint1 = arcBeam.midPoint1;
    const midPoint2 = arcBeam.midPoint2;

    // 使用提供的中点分割弧线
    const splitParts = splitArcBeamLines(arcPoints, midPoint1, midPoint2);
    if (splitParts) {
      if (splitParts[0].length > splitParts[1].length) {
        arcLines1.push(splitParts[0]);
        arcLines2.push(splitParts[1]);
      } else {
        arcLines1.push(splitParts[1]);
        arcLines2.push(splitParts[0]);
      }
      // 绘制分割后的两部分
      // let polyline1 = new McDbPolyline();
      // let polyline2 = new McDbPolyline();

      // // 添加第一部分的点
      // for (const pt of splitParts[0]) {
      //   polyline1.addVertexAt(pt);
      // }

      // // 添加第二部分的点
      // for (const pt of splitParts[1]) {
      //   polyline2.addVertexAt(pt);
      // }

      // // 绘制多段线
      // let polyline11 = rlAppObj.mxcadObject.drawEntity(polyline1);
      // let polyline22 = rlAppObj.mxcadObject.drawEntity(polyline2);

      // // 设置图层
      // polyline11.getMcDbEntity().layerId = beamLineLayer1;
      // polyline22.getMcDbEntity().layerId = beamLineLayer2;
      // polyline11.getMcDbEntity().trueColor = new McCmColor(0, 170, 170);
      // polyline22.getMcDbEntity().linetype = "MyBeamLineType";
      // polyline22.getMcDbEntity().trueColor = new McCmColor(0, 170, 170);

      // // 添加到绘制的线段列表
      // otherLineId.push(polyline11);
      // otherLineId.push(polyline22);
    }
  }

  for (const item of beamLongLines) {
    let pt1InPts = false;
    let pt2InPts = false;
    for (const itemSlab of zeroSlabPolyLines) {
      if (!pt1InPts) {
        if (isPointInPolygon(item[0], itemSlab, 0.1)) {
          pt1InPts = true;
        }
      }
      if (!pt2InPts) {
        if (isPointInPolygon(item[1], itemSlab, 0.1)) {
          pt2InPts = true;
        }
      }
      for (let i = 0; i < itemSlab.length; i++) {
        let nextIndex = i + 1;
        if (nextIndex >= itemSlab.length) {
          nextIndex = 0;
        }
        let pt1 = itemSlab[i];
        let pt2 = itemSlab[nextIndex];
        let pt3 = item[0];
        let pt4 = item[1];
        pt1.z = pt2.z = pt3.z = pt4.z;
        let intersection = lineInsection(pt1, pt2, pt3, pt4, false);
        if (intersection && intersection.isIntersected) {
          let pt = new McGePoint3d(
            intersection.intersectionPoint.x,
            intersection.intersectionPoint.y,
            intersection.intersectionPoint.z
          );
          let dist1 = pt.distanceTo(pt3);
          let dist2 = pt.distanceTo(pt4);
          if (dist1 < dist2) {
            pt1InPts = true;
          } else {
            pt2InPts = true;
          }
        }
      }
      if (pt1InPts && pt2InPts) {
        break;
      }
    }
    if (pt1InPts && pt2InPts) {
      let pt1 = item[0];
      let pt2 = item[1];
      let vec = new THREE.Vector3().subVectors(pt2, pt1).normalize();
      let vec1 = new THREE.Vector3(-vec.x, -vec.y, 0);
      pt1 = MovePt(pt1, vec1, 100);
      pt2 = MovePt(pt2, vec, 100);
      let tmp = [];
      tmp.push(pt1);
      tmp.push(pt2);
      beamLines1.push(item);
      continue;
    }
    for (const itemSlab of slabPolyLines) {
      if (!pt1InPts) {
        if (isPointInPolygon(item[0], itemSlab, 0.1)) {
          pt1InPts = true;
        }
      }
      if (!pt2InPts) {
        if (isPointInPolygon(item[1], itemSlab, 0.1)) {
          pt2InPts = true;
        }
      }
      for (let i = 0; i < itemSlab.length; i++) {
        let nextIndex = i + 1;
        if (nextIndex >= itemSlab.length) {
          nextIndex = 0;
        }
        let pt1 = itemSlab[i];
        let pt2 = itemSlab[nextIndex];
        let pt3 = item[0];
        let pt4 = item[1];
        pt1.z = pt2.z = pt3.z = pt4.z;
        let intersection = lineInsection(pt1, pt2, pt3, pt4, false);
        if (intersection && intersection.isIntersected) {
          let pt = new McGePoint3d(
            intersection.intersectionPoint.x,
            intersection.intersectionPoint.y,
            intersection.intersectionPoint.z
          );
          let dist1 = pt.distanceTo(pt3);
          let dist2 = pt.distanceTo(pt4);
          if (dist1 < dist2) {
            pt1InPts = true;
          } else {
            pt2InPts = true;
          }
        }
        if (pt1InPts && pt2InPts) {
          break;
        }
      }
    }
    if (pt1InPts && pt2InPts) {
      beamLines2.push(item);
    } else {
      let pt1 = item[0];
      let pt2 = item[1];
      let vec = new THREE.Vector3().subVectors(pt2, pt1).normalize();
      let vec1 = new THREE.Vector3(-vec.x, -vec.y, 0);
      pt1 = MovePt(pt1, vec1, 100);
      pt2 = MovePt(pt2, vec, 100);
      let tmp = [];
      tmp.push(pt1);
      tmp.push(pt2);
      beamLines1.push(tmp);
    }
  }
  // 设置虚线类型
  mxcad.addLinetype("MyBeamLineType", "300,-200");
  mxcad.addLinetype("MyBeamArcLineType", "50,-20");
  //绘制虚线
  const processedResult2 = replaceSegmentEndpointWithIntersection(
    beamLines2,
    arcLines2
  );
  const updatedBeamLines2 = processedResult2.lines;
  const updatedArcLines2 = processedResult2.arcs;

  // 绘制更新后的直线
  for (const item of updatedBeamLines2) {
    let line = mxcad.drawLine(item[0].x, item[0].y, item[1].x, item[1].y);
    let line1 = line.getMcDbEntity();
    line1.layerId = beamLineLayer2;
    line1.linetype = "MyBeamLineType";
    line1.trueColor = new McCmColor(0, 170, 170);
    otherLineId.push(line);
  }

  // 绘制更新后的弧线（虚线）
  for (const arcPoints of updatedArcLines2) {
    if (arcPoints && arcPoints.length >= 2) {
      let polyline = new McDbPolyline();

      // 添加弧线上的点
      for (const pt of arcPoints) {
        polyline.addVertexAt(pt);
      }

      // 绘制多段线
      let polylineEntity = rlAppObj.mxcadObject.drawEntity(polyline);

      // 设置图层和样式
      let line1 = polylineEntity.getMcDbEntity();
      line1.layerId = beamLineLayer2;
      line1.linetype = "MyBeamArcLineType";
      line1.trueColor = new McCmColor(0, 170, 170);
      // 添加到绘制的线段列表
      otherLineId.push(polylineEntity);
    }
  }

  //绘制实线
  const processedResult1 = replaceSegmentEndpointWithIntersection(
    beamLines1,
    arcLines1
  );
  const updatedBeamLines1 = processedResult1.lines;
  const updatedArcLines1 = processedResult1.arcs;

  // 绘制更新后的直线
  for (const item of updatedBeamLines1) {
    let line = mxcad.drawLine(item[0].x, item[0].y, item[1].x, item[1].y);
    let line1 = line.getMcDbEntity();
    line1.layerId = beamLineLayer1;
    line1.trueColor = new McCmColor(0, 170, 170);
    otherLineId.push(line);
  }

  // 绘制更新后的弧线（实线）
  for (const arcPoints of updatedArcLines1) {
    if (arcPoints && arcPoints.length >= 2) {
      let polyline = new McDbPolyline();

      // 添加弧线上的点
      for (const pt of arcPoints) {
        polyline.addVertexAt(pt);
      }

      // 绘制多段线
      let polylineEntity = rlAppObj.mxcadObject.drawEntity(polyline);

      // 设置图层和样式
      polylineEntity.getMcDbEntity().layerId = beamLineLayer1;
      polylineEntity.getMcDbEntity().trueColor = new McCmColor(0, 170, 170);

      // 添加到绘制的线段列表
      otherLineId.push(polylineEntity);
    }
  }
};

/**
 * 替换线段端点为交点
 * @param {Array} lines 线段数组，每个元素为 [McGePoint3d, McGePoint3d]
 * @param {Array} arcs 弧线数组，每个元素为点集数组 [McGePoint3d, ...]
 * @returns {Object} 包含更新后的线段和弧线: {lines: 新线段数组, arcs: 新弧线数组}
 */
export const replaceSegmentEndpointWithIntersection = (lines, arcs = []) => {
  // 深拷贝，避免修改原数组
  const newLines = lines.map((seg) => [seg[0].clone(), seg[1].clone()]);

  // 深拷贝弧线数组
  const newArcs = arcs.map((arc) =>
    arc.map((pt) =>
      pt.clone ? pt.clone() : new McGePoint3d(pt.x, pt.y, pt.z || 0)
    )
  );

  // 处理直线与直线的交点
  for (let i = 0; i < newLines.length; i++) {
    for (let j = 0; j < newLines.length; j++) {
      if (i === j) continue;
      const segA = newLines[i];
      const segB = newLines[j];
      // 判断是否相交
      const intersection = lineInsection(
        segA[0],
        segA[1],
        segB[0],
        segB[1],
        false // 按你的需求传isGrid参数
      );
      if (intersection && intersection.isIntersected) {
        const pt = new McGePoint3d(
          intersection.intersectionPoint.x,
          intersection.intersectionPoint.y,
          intersection.intersectionPoint.z
        );
        // 计算segA哪个端点更近
        const dist0 = segA[0].distanceTo(pt);
        const dist1 = segA[1].distanceTo(pt);
        if (dist0 < dist1) {
          segA[0] = pt.clone
            ? pt.clone()
            : new McGePoint3d(pt.x, pt.y, pt.z || 0);
        } else {
          segA[1] = pt.clone
            ? pt.clone()
            : new McGePoint3d(pt.x, pt.y, pt.z || 0);
        }
      }
    }
  }

  // 处理直线与弧线的交点
  if (newArcs && newArcs.length > 0) {
    for (let i = 0; i < newLines.length; i++) {
      const segA = newLines[i];

      for (let j = 0; j < newArcs.length; j++) {
        const arcPoints = newArcs[j];

        // 跳过点数不足的弧线
        if (!arcPoints || arcPoints.length < 3) continue;

        let arcIntersections = []; // 存储弧线与当前直线的所有交点

        // 对弧线的每个线段进行检查
        for (let k = 0; k < arcPoints.length - 1; k++) {
          const arcPt1 = arcPoints[k];
          const arcPt2 = arcPoints[k + 1];

          // 使用lineInsection检查直线与弧线线段的交点
          const intersection = lineInsection(
            segA[0],
            segA[1],
            arcPt1,
            arcPt2,
            false
          );

          if (intersection && intersection.isIntersected) {
            const pt = new McGePoint3d(
              intersection.intersectionPoint.x,
              intersection.intersectionPoint.y,
              intersection.intersectionPoint.z
            );

            arcIntersections.push({
              point: pt,
              segmentIndex: k,
            });

            // 计算到线段两端点的距离
            const dist0 = segA[0].distanceTo(pt);
            const dist1 = segA[1].distanceTo(pt);

            // 更新距离交点较近的端点
            if (dist0 < dist1) {
              segA[0] = pt.clone
                ? pt.clone()
                : new McGePoint3d(pt.x, pt.y, pt.z || 0);
            } else {
              segA[1] = pt.clone
                ? pt.clone()
                : new McGePoint3d(pt.x, pt.y, pt.z || 0);
            }
          }
        }

        // 如果找到交点，更新弧线
        if (arcIntersections.length > 0) {
          // 按照在弧线上的位置排序
          arcIntersections.sort((a, b) => a.segmentIndex - b.segmentIndex);

          if (arcIntersections.length === 1) {
            // 只有一个交点，需要判断是在弧线的开始还是结束
            const intersectionPt = arcIntersections[0].point;
            const segmentIdx = arcIntersections[0].segmentIndex;

            // 计算交点到弧线起点和终点的距离
            const distToStart = intersectionPt.distanceTo(arcPoints[0]);
            const distToEnd = intersectionPt.distanceTo(
              arcPoints[arcPoints.length - 1]
            );

            if (distToStart < distToEnd) {
              // 交点更接近起点，保留终点到交点
              newArcs[j] = [intersectionPt].concat(
                arcPoints.slice(segmentIdx + 1)
              );
            } else {
              // 交点更接近终点，保留起点到交点
              newArcs[j] = arcPoints
                .slice(0, segmentIdx + 1)
                .concat([intersectionPt]);
            }
          } else if (arcIntersections.length >= 2) {
            // 两个或多个交点，取中间部分
            const firstIdx = arcIntersections[0].segmentIndex;
            const lastIdx =
              arcIntersections[arcIntersections.length - 1].segmentIndex;

            // 创建新的弧线数组，只包含两个交点之间的部分
            newArcs[j] = [arcIntersections[0].point]
              .concat(arcPoints.slice(firstIdx + 1, lastIdx + 1))
              .concat([arcIntersections[arcIntersections.length - 1].point]);
          }
        }
      }
    }
  }

  return {
    lines: newLines,
    arcs: newArcs,
  };
};

//绘制坐标系
export const drawCoordinateSystem = () => {
  const mxcad = MxCpp.getCurrentMxCAD();
  const coordinateSystemLayer = mxcad.addLayer("坐标系");
  const allJoint = store.state.rlEntData.totalEntityData["rlJoint"];
  let box = new THREE.Box3();
  for (const item of allJoint) {
    box.expandByPoint(new McGePoint3d(...item.m_pt));
  }
  let minPt = box.min;
  let maxPt = box.max;
  let xDist = Math.abs(maxPt.x - minPt.x);
  let yDist = Math.abs(maxPt.y - minPt.y);
  minPt.x -= 3500;
  minPt.y -= 3500;
  let ptX1 = MovePt(minPt, new THREE.Vector3(1, 0, 0), xDist + 3500);
  let ptY1 = MovePt(minPt, new THREE.Vector3(0, 1, 0), yDist + 3500);
  // let ptX2 = MovePt(minPt, new THREE.Vector3(-1, 0, 0), 3000);
  // let ptY2 = MovePt(minPt, new THREE.Vector3(0, -1, 0), 3000);
  let lineX = mxcad.drawLine(ptX1.x, ptX1.y, minPt.x, minPt.y);
  let lineY = mxcad.drawLine(ptY1.x, ptY1.y, minPt.x, minPt.y);
  lineX.getMcDbEntity().layerId = coordinateSystemLayer;
  lineY.getMcDbEntity().layerId = coordinateSystemLayer;
  otherLineId.push(lineX);
  otherLineId.push(lineY);
  let textX = mxcad.drawText(ptX1.x - 1000, ptX1.y - 1000, "X", 1000);
  let textY = mxcad.drawText(ptY1.x - 1000, ptY1.y - 1000, "Y", 1000);
  textX.getMcDbEntity().layerId = coordinateSystemLayer;
  textY.getMcDbEntity().layerId = coordinateSystemLayer;
  otherLineId.push(textX);
  otherLineId.push(textY);
};

//隐藏所有构件
export const hideAllComponent = async () => {
  for (const [key, item] of Object.entries(ents)) {
    if (Array.isArray(item)) {
      setVisible(item, false);
    }
  }
};

//复原原本构件的显隐状态
export const restoreComponent = async () => {
  for (const [key, item] of Object.entries(ents)) {
    if (Array.isArray(item)) {
      setVisible(item, beforeShow[key]);
    }
  }
};

//获取构件的显隐状态
export const getComponentVisible = () => {
  beforeShow = {
    rlAxis: store.state.displayData.rlLayerDisplay.includes(2),
    rlGrid: store.state.displayData.rlLayerDisplay.includes(3),
    rlColSeg: store.state.displayData.rlLayerDisplay.includes(4),
    rlBeamSeg: store.state.displayData.rlLayerDisplay.includes(5),
    rlWallSeg: store.state.displayData.rlLayerDisplay.includes(6),
    rlSlab: store.state.displayData.rlLayerDisplay.includes(7),
    rlSlabHole: store.state.displayData.rlLayerDisplay.includes(12),
    rlCantiSlab: store.state.displayData.rlLayerDisplay.includes(12),
    rlSubBeam: store.state.displayData.rlLayerDisplay.includes(9),
    rlWallHole: store.state.displayData.rlLayerDisplay.includes(10),
    rlModelNo: store.state.displayData.rlLayerDisplay.includes(11),
    rlText: store.state.displayData.rlLayerDisplay.includes(18),
    rlPartitionWallSeg: store.state.displayData.rlLayerDisplay.includes(21),
    rlDoors: store.state.displayData.rlLayerDisplay.includes(22),
    rlWindows: store.state.displayData.rlLayerDisplay.includes(23),
    rlUse: store.state.displayData.rlLayerDisplay.includes(24),
    rlCheck: store.state.displayData.rlLayerDisplay.includes(25),
  }; //之前构件的显隐状态
};

//结构平面图设置
export const structurePlaneSetting = async (
  isShow,
  type = "平面图",
  isDwg = true
) => {
  getComponentVisible();
  if (isShow) {
    if (type == "倾斜测点图" || type == "沉降测点图") {
      await drawCoordinateSystem();
    }
    await drawCompass();
    await setStructureComponentLayer();
    await showHideStructureComponent(true, type, isDwg);
    await drawBeamLine();
    await new Promise((resolve) => setTimeout(resolve, 50));
    await addFillToWallAndColumn();
    await new Promise((resolve) => setTimeout(resolve, 100));
  } else {
    await deleteAllHatch();
    await deleteCompass();
    await showHideStructureComponent(false, type, isDwg);
    deleteOtherLines(); // 新增：清理其他线段
  }
};

//建筑平面图设置
export const buildingPlaneSetting = async (isShow) => {
  getComponentVisible();
  if (isShow) {
    await drawCompass();
    await setBuildingComponentLayer();
    await showHideBuildingComponent(true);
    await new Promise((resolve) => setTimeout(resolve, 50));
    await addFillToWallAndColumn();
    await new Promise((resolve) => setTimeout(resolve, 100));
  } else {
    await deleteAllHatch();
    await deleteCompass();
    await showHideBuildingComponent(false);
  }
};

export const splitArcBeamLines = (arcPoints, midPoint1, midPoint2) => {
  if (!arcPoints || arcPoints.length < 3) {
    return null;
  }

  // 找到每个中点所在的线段
  let startIndex = -1;
  let findMinPoint = null;
  midPoint1.z = arcPoints[0].z;
  midPoint2.z = arcPoints[0].z;
  for (let i = 0; i < arcPoints.length; i++) {
    let nextIndex = i + 1;
    if (nextIndex >= arcPoints.length) {
      nextIndex = 0;
    }
    let pt1 = arcPoints[i];
    let pt2 = arcPoints[nextIndex];
    if (ptOnLine(pt1, pt2, midPoint1) != -1) {
      startIndex = nextIndex;
      findMinPoint = midPoint2;
      break;
    }
    if (ptOnLine(pt1, pt2, midPoint2) != -1) {
      startIndex = nextIndex;
      findMinPoint = midPoint1;
      break;
    }
  }
  if (startIndex == -1) {
    return null;
  }
  //重新排序，使startIndex为0
  let tmp = [];
  for (let i = startIndex; i < arcPoints.length; i++) {
    tmp.push(arcPoints[i]);
  }
  for (let i = 0; i < startIndex; i++) {
    tmp.push(arcPoints[i]);
  }
  arcPoints = tmp;
  let pts1 = [];
  let pts2 = [];
  for (let i = 0; i < arcPoints.length; i++) {
    let nextIndex = i + 1;
    if (nextIndex >= arcPoints.length) {
      nextIndex = 0;
    }
    let pt1 = arcPoints[i];
    let pt2 = arcPoints[nextIndex];
    if (ptOnLine(pt1, pt2, findMinPoint) != -1) {
      pts1.push(pt1);
      pts2.push(pt2);
    } else {
      if (pts2.length == 0) {
        pts1.push(pt1);
      } else {
        pts2.push(pt1);
      }
    }
  }
  return [pts1, pts2];
};

export const drawAnyLine = async (arr) => {
  if (arr) {
    // 实例化取点对象
    arr.map(async (item) => {
      const polyline = new McDbPolyline();
      item.points.forEach((element) => {
        let pt = new McGePoint3d(element.x, element.y, element.z);
        polyline.addVertexAt(pt);
      });
      // 添加到画布
      item.lineId = rlAppObj.mxcadObject.drawEntity(polyline);
      var res = await drawTextsVue(item);
      item = res;
    });
    rlAppObj.rlMxDrawObject.updateDisplay();
  }
};
// 绘制圆和文字
export const drawTextsVue = async (obj) => {
  var { points } = obj;
  const coordinates =
    points[0].y > points[points.length - 1].y
      ? points[0]
      : points[points.length - 1];
  // 绘制圆
  const stExternPos = new THREE.Vector3(
    coordinates.x + 450,
    coordinates.y + 450,
    0
  );
  const addobj = await drawTexts(obj, stExternPos);
  // //绘制文字
  return addobj;
};
